import {NotificationBase} from "./notification-base";

export class NotificationActionbox extends NotificationBase {
    getActions()
    {
        return this.notification?.additionalFields?.actions ?? [];
    }

    hasActions()
    {
        return this.notification?.additionalFields?.actions?.length > 0;
    }
}
